/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessMarketplaceFeeBody
 */
export interface UpdateBusinessMarketplaceFeeBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessMarketplaceFeeBody
     */
    marketplacePercentageDelivery?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessMarketplaceFeeBody
     */
    marketplacePercentagePickup?: number;
}

/**
 * Check if a given object implements the UpdateBusinessMarketplaceFeeBody interface.
 */
export function instanceOfUpdateBusinessMarketplaceFeeBody(value: object): value is UpdateBusinessMarketplaceFeeBody {
    return true;
}

export function UpdateBusinessMarketplaceFeeBodyFromJSON(json: any): UpdateBusinessMarketplaceFeeBody {
    return UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json, false);
}

export function UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessMarketplaceFeeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'marketplacePercentageDelivery': json['marketplacePercentageDelivery'] == null ? undefined : json['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': json['marketplacePercentagePickup'] == null ? undefined : json['marketplacePercentagePickup'],
    };
}

export function UpdateBusinessMarketplaceFeeBodyToJSON(json: any): UpdateBusinessMarketplaceFeeBody {
    return UpdateBusinessMarketplaceFeeBodyToJSONTyped(json, false);
}

export function UpdateBusinessMarketplaceFeeBodyToJSONTyped(value?: UpdateBusinessMarketplaceFeeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'marketplacePercentageDelivery': value['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': value['marketplacePercentagePickup'],
    };
}

